<template>
  <div class="body-wrapper documents">
    <div class="body-wrapper table-poll">
      <div class="table-wrapper">
        <spinner
          class="spinner"
          line-fg-color="#00796b"
          :size="100"
          :line-size="6"
          v-if="loading"
        ></spinner>
        <div v-show="!loading">
          <button
            v-if="$router.history.current.name == 'communityDocuments'"
            @click="showModal('ModalContentAddDocument')"
            class="btn btn-add"
          >
            Dodaj dokument
          </button>
          <data-table
            :columns="table.tableColumns"
            :tableData="tableData"
            :options="table.tableOptions"
            :slotNameActionCommunityDocuments="'action'"
          ></data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapActions, mapState, mapMutations } from 'vuex';
import dataTable from '@/components/community/Table.vue';
import Pagination from '@/components/common/Pagination.vue';

export default {
  name: 'communityDocumentView',
  async created() {
    this.cardOpened();
    this.setTableBadge('fas fa-file-alt');
    this.loading = true;
    await this.getDocumentForCommunity(
      this.$store.getters.getActiveCommunity.id
    );
    this.loading = false;
  },
  data() {
    return {
      table: {
        tableColumns: ['file_name', 'action'],
        tableOptions: {
          filterable: true,
          headings: {
            file_name: 'Naziv',
            action: ''
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje dokumenta'
          },
          sortable: ['file_name']
        }
      },
      loading: false,
      communityDocuments: []
    };
  },
  computed: {
    ...mapState('table', ['tableColumns', 'tableData', 'tableOptions'])
  },
  components: {
    dataTable
  },
  methods: {
    ...mapMutations(['cardOpened']),
    ...mapMutations('table', ['setTableBadge']),
    ...mapMutations('modal', ['showModal']),
    ...mapActions('table', ['getDocumentForCommunity'])
  }
};
</script>

<style lang="scss">
.documents {
  display: block;
  padding: 10px;
  th.VueTables__sortable {
    width: 70%;
  }
  .table-wrapper {
    position: relative;
  }
  .btn-add {
    background: var(--primary-color);
    color: white;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }

  .btn:focus {
    box-shadow: none;
  }
}
</style>
